<!-- 菜单：支付沙盒 /pages/dev/paymentSandboxManage -->
<template>
  <div class="payment-sandbox-container">
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>微信支付沙盒密钥管理</span>
        <el-button type="primary" size="small" @click="handleGetSignKey">
          <i class="el-icon-refresh"></i>
          获取沙盒密钥
        </el-button>
      </div>

      <el-form ref="form" :model="formData" :rules="rules" label-width="150px">
        <el-form-item label="商户号(mchId)" prop="mchId">
          <el-input
            v-model="formData.mchId"
            placeholder="请输入商户号"
            clearable
          />
        </el-form-item>
        <el-form-item label="API密钥(key)" prop="key">
          <el-input
            v-model="formData.key"
            placeholder="请输入API密钥(32位)"
            clearable
            show-password
          />
        </el-form-item>
      </el-form>

      <el-divider content-position="left">沙盒密钥信息</el-divider>

      <el-table :data="sandboxList" border style="width: 100%" v-loading="loading">
        <el-table-column prop="mchId" label="商户号" align="center" />
        <el-table-column prop="sandboxKey" label="沙盒密钥" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.sandboxKey">{{ scope.row.sandboxKey }}</span>
            <span v-else class="color-gray">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="signKey" label="签名密钥" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.signKey">{{ scope.row.signKey }}</span>
            <span v-else class="color-gray">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center" width="180" />
        <el-table-column label="操作" align="center" width="150">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleCopy(scope.row.sandboxKey)">
              复制密钥
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { getWechatSandboxSignKey } from '@/api/dev/paymentSandboxApi'
import { getCommunityId } from '@/api/community/communityApi'

export default {
  name: 'PaymentSandboxManage',
  data() {
    return {
      loading: false,
      formData: {
        mchId: '',
        key: ''
      },
      rules: {
        mchId: [
          { required: true, message: '请输入商户号', trigger: 'blur' }
        ],
        key: [
          { required: true, message: '请输入API密钥', trigger: 'blur' },
          { len: 32, message: 'API密钥必须为32位', trigger: 'blur' }
        ]
      },
      sandboxList: [],
      communityId: ''
    }
  },
  created() {
    this.communityId = getCommunityId()
  },
  methods: {
    async handleGetSignKey() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            this.loading = true
            const res = await getWechatSandboxSignKey({
              mchId: this.formData.mchId,
              key: this.formData.key,
              communityId: this.communityId
            })

            if (res && res.sandbox_signkey) {
              const existsIndex = this.sandboxList.findIndex(
                item => item.mchId === this.formData.mchId
              )

              const newItem = {
                mchId: this.formData.mchId,
                sandboxKey: res.sandbox_signkey,
                signKey: res.signKey || '',
                createTime: new Date().toLocaleString()
              }

              if (existsIndex > -1) {
                this.sandboxList.splice(existsIndex, 1, newItem)
              } else {
                this.sandboxList.unshift(newItem)
              }

              this.$message.success('获取沙盒密钥成功')
            } else {
              this.$message.warning('未获取到沙盒密钥')
            }
          } catch (error) {
            this.$message.error(error.message || '获取沙盒密钥失败')
          } finally {
            this.loading = false
          }
        }
      })
    },
    handleCopy(text) {
      if (!text) return
      this.$copyText(text).then(() => {
        this.$message.success('复制成功')
      }).catch(() => {
        this.$message.error('复制失败')
      })
    }
  }
}
</script>

<style scoped>
.payment-sandbox-container {
  padding: 20px;
}

.box-card {
  margin-bottom: 20px;
}

.flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
}

.color-gray {
  color: #999;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>
